import { getApiUrl } from "../../constants/pathConstants"
import { communityStateData } from "../../data/communityStateData"
import { userStateData } from "../../data/userStateData"
import { API_END_POINT_GET_ALL_COMMUNITIES, API_END_POINT_GET_COMMUNITIES_FOR_USER, API_END_POINT_JOIN_COMMUNITY, API_END_POINT_LEAVE_COMMUNITY } from "../endPoints"
import { CommunitiesRequestResponse, CommunityData } from "../types"

class CommunityConnector {
	requestInProgress: boolean = false

	public async getAllCommunitiesRequest(): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [CommunityConnector]] getAllCommunitiesRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				await fetch(`${getApiUrl()}${API_END_POINT_GET_ALL_COMMUNITIES}?cache=${Math.random()}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data: CommunitiesRequestResponse) => {
						// console.log(data)
						if (data.communities) {
							communityStateData.communities = data.communities

						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[CommunityConnector] - getAllCommunitiesRequest() failed')
			console.log(err)
			return false
		}
	}

	public async getCommunitiesForUserRequest(userId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				// this.requestInProgress = false
				console.log('WARNING - [CommunityConnector]] getCommunitiesForUserRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("id", userId)
				urlParams.append("cache", `${Math.random()}`)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				await fetch(`${getApiUrl()}${API_END_POINT_GET_COMMUNITIES_FOR_USER}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data: CommunitiesRequestResponse) => {
						if (data.communities) {
							data.communities.forEach((community: CommunityData) => {
								userStateData.addCommunity(community.community_name, parseInt(community.id))
							})
							communityStateData.userCommunities = data.communities as CommunityData[]
							// communityStateData.communities = data.communities
						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[CommunityConnector] - getCommunitiesForUserRequest() failed')
			console.log(err)
			return false
		}
	}

	public async joinCommunityRequest(community_id: string, user_id: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [CommunityConnector] joinCommunityRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_JOIN_COMMUNITY}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"community_id": community_id,
						"user_id": user_id
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[CommunityConnector] - joinCommunityRequest() failed')
			console.log(err)
			return false
		}
	}

	public async leaveCommunityRequest(community_id: string, user_id: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [CommunityConnector] leaveCommunityRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_LEAVE_COMMUNITY}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"community_id": community_id,
						"user_id": user_id
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[CommunityConnector] - leaveCommunityRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const communityConnector: CommunityConnector = new CommunityConnector()